import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  CheckTransactionSearchCriteria,
  PageListBean,
  RestCheckTransactionListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
export class CheckTransactionLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new CheckTransactionSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new CheckTransactionSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let checkTransactionLookupCriteria = new CheckTransactionSearchCriteria();
    checkTransactionLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = CheckTransactionLookupCriteriaHandler(
      companyCode,
      checkTransactionLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      checkTransactionLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getCheckTransactionStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("VendorCode", "vendorCode", 0, false); //2
    this.addColumnDefinition("VendorName", "vendorName", 0, false); //3
    this.addColumnDefinition("Status", "status", 0, false); //4
    this.addColumnDefinition("Transaction Type", "transactionType", 0, false);
  }
  loadCheckTransactionList = (lookup_dialog, pageNumber, searchCriteria) => {
    let checktransaction_criteria = new CheckTransactionSearchCriteria(); //To be fetched from CriteriaHandler
    checktransaction_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      checktransaction_criteria.checkTransactionNumber =
        searchCriteria.checkTransactionNumber;
      checktransaction_criteria.vendorCode = searchCriteria.vendorCode;
      checktransaction_criteria.checkTransactionNumberContains =
        searchCriteria.checkTransactionNumberContains;
      checktransaction_criteria.checkTransactionStatus =
        searchCriteria.checkTransactionStatus;
    }
    let checktransaction_pageList = new PageListBean();
    checktransaction_pageList.pageSize = 50; //TODO --> Fetch from Config
    checktransaction_pageList.currentPage = pageNumber;
    checktransaction_pageList.pageNumber = pageNumber;
    let checktransaction_requestInput = new RestCheckTransactionListRequest();
    checktransaction_requestInput.pageInput = checktransaction_pageList;
    checktransaction_requestInput.searchCriteria = checktransaction_criteria;
    AccountPayableService.getCheckTransactionPageList(
      checktransaction_requestInput,
      (response) =>
        this.loadCheckTransactionListResponse(response, lookup_dialog),
      this.loadCheckTransactonListError
    );
  };
  loadCheckTransactionListResponse = (response, lookup_dialog) => {
    let checkTransactionList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.pageList != null &&
      response.data.pageList.checkTransactions !== null
    ) {
      checkTransactionList = response.data.pageList.checkTransactions;
      totalCount = response.data.pageList.totalCount;
      currentPageNumber = response.data.pageList.currentPage;
      pageSize = response.data.pageList.pageSize;
      checkTransactionList.map((ct) => {
        ct.status = ModuleUtils.getCheckTransactionStatusCaption(ct.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = checkTransactionList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCheckTransactonListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.checkTransactionNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.checkTransactionNumberContains = filterText;
        this.searchCriteria = new CheckTransactionSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCheckTransactionList(lookup_dialog, pageNumber, search);
    }
  }
}

const CheckTransactionLookupCriteriaHandler = (companyCode) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CheckTransactionSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new CheckTransactionSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CheckTransactionNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="checkTransactionNumber"
                  name="checkTransactionNumber"
                  onChange={this.onChange}
                  value={searchCriteria.checkTransactionNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="checkTransactionStatus"
                  value={searchCriteria.checkTransactionStatus}
                >
                  <option value={""}></option>
                  <option value={"O"}>Open</option>
                  <option value={"P"}>Printed</option>
                  <option value={"V"}>Voided</option>
                </FormControl>
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
